import Component from './HeaderResizable.component';

export const headerType = 'resizable';
Component.headerType = headerType;

export default Component;
